<div class="download-header">
  <!--    <p >{{ "downloads.my-downloads" | translate }}</p>-->
  <inline-svg src="downloads.svg" className="menu-icon"
    (click)="goBack()"
    hoverColor="#7F8F98"
    activeColor="#85BBF3"
  ></inline-svg>
  <img src="assets/icons/page_back.svg" alt="" width="8px" height="13px">
  <p>
    {{ taskGroup?.name }}
  </p>
</div>

<!--<div class="download-summary">-->
<!--    <div class="summary-header">-->
<!--        {{ "downloads.request-stats" | translate }}-->
<!--    </div>-->
<!--    <div class="summary-container">-->
<!--        <ng-template [ngTemplateOutlet]="summaryCard"-->
<!--                     [ngTemplateOutletContext]="{-->
<!--        value: statistic.completed,-->
<!--        title: 'downloads.processed',-->
<!--        icon: 'new_releases'-->
<!--        }"></ng-template>-->
<!--        <ng-template [ngTemplateOutlet]="summaryCard"-->
<!--                     [ngTemplateOutletContext]="{-->
<!--        value: statistic.started,-->
<!--        title: 'downloads.processing',-->
<!--        icon: 'progress_activity'-->
<!--        }">-->
<!--        </ng-template>-->
<!--&lt;!&ndash;        <ng-template [ngTemplateOutlet]="summaryCard"&ndash;&gt;-->
<!--&lt;!&ndash;                     [ngTemplateOutletContext]="{&ndash;&gt;-->
<!--&lt;!&ndash;        value: statistic.cancelled,&ndash;&gt;-->
<!--&lt;!&ndash;        title: 'downloads.canceled',&ndash;&gt;-->
<!--&lt;!&ndash;        icon: 'hide_source'&ndash;&gt;-->
<!--&lt;!&ndash;        }">&ndash;&gt;-->
<!--&lt;!&ndash;        </ng-template>&ndash;&gt;-->
<!--&lt;!&ndash;        <ng-template [ngTemplateOutlet]="summaryCard"&ndash;&gt;-->
<!--&lt;!&ndash;                     [ngTemplateOutletContext]="{&ndash;&gt;-->
<!--&lt;!&ndash;        value: statistic.failed,&ndash;&gt;-->
<!--&lt;!&ndash;        title: 'downloads.expired',&ndash;&gt;-->
<!--&lt;!&ndash;        icon: 'timer_off'&ndash;&gt;-->
<!--&lt;!&ndash;        }"></ng-template>&ndash;&gt;-->

<!--    </div>-->
<!--</div>-->

<div class="download-table">
    <div class="table-header">
        Areas
    </div>
    <div class="table-container">
        <div class="pseudo-header">
            <inline-svg src="arrow-middle.svg" class="arrow-icon"
                        color="#A5B5BD"
  ></inline-svg>
  <span>Area Name</span>
  <span>Status</span>
  <span class="pseudo-action"></span>
</div>
<div class="horizontal-separator">
</div>
<div class="pseudo-table-body">
  <mat-accordion>
    @for (element of taskData; track element) {
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <inline-svg src="arrow-middle.svg" class="arrow-icon"
            color="#A5B5BDFF"
          ></inline-svg>
          <span class="name_column">{{ element.name }}</span>
          <span>
            <div class="status-block">
              <span [ngClass]="statusClass(element)"></span>
              <span>{{ element.status === 'pending' ? (element.completed_tasks + "/" + element.total_tasks) : '' }} {{ taskStatusTranslations.get(element.status) | translate }}</span>
            </div>
          </span>
          <div class="button download-button" (click)="download(element, $event)">
            <inline-svg src="download.svg" class="download-icon"
              color="#F7F9F9FF"
            ></inline-svg>
            <span>Download</span>
          </div>
          <div class="button" (click)="deleteDownload(element, $event)">
            <inline-svg src="remove.svg" class="delete-icon"
              color="#A5B5BDFF"
              hoverColor="#7F8F98"
            ></inline-svg>
          </div>
        </mat-expansion-panel-header>
        <div class="horizontal-separator">
        </div>
        @for (task of element.tasks; track task) {
          <div class="layers-name">
            {{ task.layer.display_name }}
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
</div>
<mat-divider></mat-divider>
<mat-paginator
  [length]="totalElements"
  [pageIndex]="currentPage-1"
  [pageSize]="pageSize"
  [pageSizeOptions]="[50, 100, 15]"
  [showFirstLastButtons]="true"
  (page)="handlePageEvent($event)"
></mat-paginator>

</div>

<ng-template #summaryCard let-value="value" let-title="title" let-icon="icon">
  <div class="summary-card">
    <div class="card-info">
      <p class="card-reading">{{ value }}</p>
      <p class="card-title">{{ title | translate }}</p>
    </div>
    <div class="card-icon">
      <span class="material-symbols-outlined">
        {{ icon }}
      </span>
    </div>
  </div>
</ng-template>
